import { Component } from '@angular/core';

import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-transport-templates-list',
	templateUrl: './transport-templates-list.component.html',
	styleUrls: ['./transport-templates-list.component.css'],
})
export class TransportTemplatesListComponent extends ListComponent {
	protected apiUrl = 'bag/bagTransportTemplates';
	tableRows = [
		{ id: 'name', name: 'Nazwa' },
		{ id: 'created', name: 'Utworzono' },
	];
}
